import { isMeetingRequest } from 'owa-meeting-message';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';
import folderIdToName from 'owa-session-store/lib/utils/folderIdToName';

// if a meeting item (after LoadItem is called - since it has all the properties) should show the RSVP button on the listview
export default function shouldMeetingItemShowRSVP(
    meetingItem: MeetingRequestMessageType | MeetingCancellationMessageType
) {
    const folderName = folderIdToName(meetingItem.ParentFolderId.Id);
    if (folderName === 'deleteditems' || folderName === 'sentitems') {
        return false;
    }

    // We only support single calendar item types
    if (meetingItem.CalendarItemType !== 'Single') {
        return false;
    }

    // Cases specific for meeting requests
    if (isMeetingRequest(meetingItem.ItemClass)) {
        const meetingRequest = meetingItem as MeetingRequestMessageType;

        // Dont want to show for no response required scenarios
        if (meetingRequest.MeetingRequestType === 'InformationalUpdate') {
            return false;
        }
    }

    return true;
}
